import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import courseDetailCss from "./CourseDetails.module.css";
import thumbCourse from "../../asset/Image/thumbCourse.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClipboard,
  faClock,
  faClone,
  faTag,
  faTags,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { BigPlayButton, Player } from "video-react";
import RestClient from "../../RestApi/RestClient";
import AppUrl from "../../RestApi/AppUrl";
export default function CourseDetails(props) {
  const {
    image,
    name,
    shortDes,
    totalEnroll,
    totalDuration,
    totalLecture,
    videoUrl,
  } = props.data;
  return (
    <>
      <div className={`${courseDetailCss.courseSignleArea} mt-5`}>
        <Container>
          <Row>
            <Col lg={8} md={8} sm={12}>
              <div className={`${courseDetailCss.courseDetailsInner}`}>
                <h3 className={`${courseDetailCss.title}`}>
                  <Link to="/courseDetails">{name}</Link>
                </h3>
                <div className={`${courseDetailCss.thumbCourse}`}>
                  <img src={image} alt="" className="img-fluid" />
                </div>
                <p className={`${courseDetailCss.courseDetail}`}>
                  {" "}
                  {shortDes}
                  {shortDes}
                  {shortDes}
                </p>
                <p className={`${courseDetailCss.courseDetail}`}>
                  {shortDes}
                  {shortDes}
                  {shortDes}
                </p>
              </div>
            </Col>
            <Col lg={4} md={4} sm={12}>
              <div className={`${courseDetailCss.courseSideBar}`}>
                <div className={`${courseDetailCss.widgetFeature}`}>
                  <h4 className={`${courseDetailCss.widgetTitle}`}>
                    Course Features
                  </h4>
                  <ul className={`${courseDetailCss.courseFeatureListWrap}`}>
                    <li>
                      <FontAwesomeIcon
                        icon={faUser}
                        className={`${courseDetailCss.icon}`}
                      />
                      <span>Enrolled :</span> {totalEnroll} students
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faClock}
                        className={`${courseDetailCss.icon}`}
                      />
                      <span>Duration :</span> {totalDuration} hours
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faClipboard}
                        className={`${courseDetailCss.icon}`}
                      />
                      <span>Lectures :</span> {totalLecture}
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faClone}
                        className={`${courseDetailCss.icon}`}
                      />
                      <span>Categories:</span> Technology
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faTags}
                        className={`${courseDetailCss.icon}`}
                      />
                      <span>Tags:</span> Android, JavaScript
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faClipboard}
                        className={`${courseDetailCss.icon}`}
                      />
                      <span>Instructor:</span> Ethan Dean
                    </li>
                  </ul>
                  <div className={`${courseDetailCss.priceWrap} text-center`}>
                    <h5>
                      Price:<span>$54.00</span>
                    </h5>
                    <a class="btn btn-warning" href="#">
                      ENROLL COURSE
                    </a>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col md={6} lg={6} sm={12}>
              <div className={`${courseDetailCss.courseSideBar}`}>
                <div className={`${courseDetailCss.widgetFeature}`}>
                  <h4 className={`${courseDetailCss.widgetTitle}`}>
                    Skills You Need
                  </h4>
                  <ul className={`${courseDetailCss.courseFeatureListWrap}`}>
                    <li>
                      <FontAwesomeIcon
                        icon={faUser}
                        className={`${courseDetailCss.icon}`}
                      />
                      <span>Enrolled :</span> {totalEnroll} students
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faClock}
                        className={`${courseDetailCss.icon}`}
                      />
                      <span>Duration :</span> {totalDuration} hours
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faClipboard}
                        className={`${courseDetailCss.icon}`}
                      />
                      <span>Lectures :</span> {totalLecture}
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faClone}
                        className={`${courseDetailCss.icon}`}
                      />
                      <span>Categories:</span> Technology
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faTags}
                        className={`${courseDetailCss.icon}`}
                      />
                      <span>Tags:</span> Android, JavaScript
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faClipboard}
                        className={`${courseDetailCss.icon}`}
                      />
                      <span>Instructor:</span> Ethan Dean
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col md={6} lg={6} sm={12}>
              <Player src={videoUrl}>
                <BigPlayButton position="center" />
              </Player>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
